var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"home sub-menu sub-menu-small h-auto"},_vm._l((_vm.menuItems),function(item){return _c('menu-item',{key:item.name,attrs:{"menu-item":item,"expiry-flag":_vm.expiryFlag}})}),1)}
var staticRenderFns = []

export { render, staticRenderFns }